/**
 * Not Progressed POST list API (`/notProgressed/list`) — `filterKeywords` field names match backend contract.
 */

export type NotProgressedListSortOrder = "Asc" | "Desc" | "ASC" | "DESC" | "";

export type NotProgressedListFilterKeywords = {
  businessCategoryName: string[];
  businessStatus: string[];
  categoryManager: string[];
  developer: string[];
  productSpecificationType: string[];
  productType: string[];
  vendorNames: string[];
  notProgressedReason: string[];
};

export type NotProgressedListPayload = {
  pageNo: number;
  pageSize: number;
  search: string;
  filterKeywords: NotProgressedListFilterKeywords;
  sortBy: string;
  sortOrder: NotProgressedListSortOrder;
  /** Included only when both from/to are selected; strings `MM/dd/yyyy HH:mm:ss`. */
  notProgressedDate?: {
    startDate: string;
    endDate: string;
  };
};

export const EMPTY_NOT_PROGRESSED_LIST_FILTER_KEYWORDS: NotProgressedListFilterKeywords = {
  businessCategoryName: [],
  businessStatus: [],
  categoryManager: [],
  developer: [],
  productSpecificationType: [],
  productType: [],
  vendorNames: [],
  notProgressedReason: [],
};

/** Map internal ASC/DESC to API `Asc` / `Desc`. */
export function toNotProgressedApiSortOrder(order: string | null | undefined): NotProgressedListSortOrder {
  const o = String(order ?? "").trim().toUpperCase();
  if (o === "ASC") return "Asc";
  if (o === "DESC") return "Desc";
  return "";
}
